<template>
    <div>
        <v-card elevation="0" width="100%">
            <v-card width="100%" elevation="0" v-if="mobile">
                <v-card-text>
                    <v-row align="center" justify="center">
                        <v-col cols="12">
                            <v-img src="../assets/background/Kings_international_3308.jpg" width="180" height="100" contain style="margin: auto;"></v-img>
                        </v-col>
                        <v-col cols="12" class="text-center">
                            <span class="text-h6" style="color:#004236;">&nbsp;&nbsp;CUPE Part-Time Job Postings</span>
                        </v-col>
                    </v-row>
                </v-card-text>
                <div style="position:fixed; right: 20px; top: 20px; z-index: 3;">
                    <v-btn color="#004236" to="/signin" fab><v-icon color="white">mdi-login</v-icon></v-btn>
                </div>
            </v-card>
            <v-card width="100%" elevation="0" class="d-flex" tile v-else>
                <v-card class="pa-2 d-flex align-content-center" elevation="0" tile>
                    <v-card-text>
                        <v-row align="center">
                            <v-img src="../assets/background/Kings_international_3308.jpg" width="200" height="120" contain></v-img>
                            <span class="text-h4" style="color:#004236;">&nbsp;&nbsp;CUPE Part-Time Job Postings</span>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card class="pa-2 ml-auto" elevation="0" tile>
                    <v-card-text><v-btn outlined color="#004236" to="/signin" >Sign In/Register</v-btn></v-card-text>
                </v-card>
            </v-card>
            <v-card color="#B2C6C2" height="5px" width="100%" flat></v-card>
            <v-card-text>
                <Search :postingid="postingid" />
            </v-card-text>
        </v-card>
    </div>
</template>
<script> 
import Search from "../components/JobPosting/Search.vue"

export default {
    name: "JobPostings",
    components: {
        Search
    },
    props: {
        postingid: {
            required: false
        }
    },
    data(){
        return {
            mobile: false,
            mobileWidthMax: 935,
        }
    },
    methods: {
        onResize() {
            const that = this;
                window.addEventListener("resize", () => {
                that.detectUX();
            });
        },
        detectUX() {                
            const that = this;
            that.mobile = window.innerWidth <= that.mobileWidthMax ? true : false;
        }
    },
    mounted() {      
      this.detectUX();
      this.onResize();      
    }
}
</script>